'use strict';

const { default: Signals } = require('Resources/Signals');

angular.module('upDirectives').directive('upEventNews', function () {
	return {
		restrict: 'A',
		templateUrl: require('App/upsales/common/directives/event/upEventNews.tpl.html?file'),
		require: 'upEventNews',
		scope: {
			event: '=upEventNews'
		},
		controller: [
			'$rootScope',
			'$scope',
			function ($rootScope, $scope) {
				$scope.addToEvents = function (event) {
					if (event.pinned || event.news || event.subType === 'Pinned') {
						return;
					}
					const clientId = event.clientId || event.client.id;
					const entityId = event.news ? event.news.entityId : event.entityId;

					Signals.pin(clientId, entityId, event.date);
				};

				$scope.removeFromEvents = function (event) {
					// For pinned news items, we need to use the eventId (from the event table)
					// For unpinned news items, we don't have an eventId yet
					let eventId;
					if (event.pinned && event.eventId) {
						// This is a pinned news item - use the eventId from the event table
						eventId = event.eventId;
					} else if (event.news && event.id) {
						// This is a news item that was just pinned but not yet saved to event table
						// We need to find the corresponding event in the scope
						// This shouldn't happen in normal flow, but let's handle it here
						return;
					}

					Signals.unpin(eventId);
				};

				$scope.open = function (url) {
					window.open(url, '_blank');
				};
			}
		]
	};
});
